import { AIResponseBlock } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const SAMPLE = `Here's a quick plan for your studio:

1. **Pick a topic** you can talk about for hours.
2. Add a few **source documents** so answers stay grounded.
3. Publish and share the link.

You can always refine the persona later.`;

export function AIResponseBlockDemo() {
  return (
    <Section
      id="ai-response-block"
      title="AIResponseBlock"
      description="Persona-attributed AI answer card: header, markdown body (via <Markdown>), source chips, and a confidence / latency / model row. App `mode` enum generalised to `contextLabel`."
    >
      <VariantBlock label="Full">
        <div className="w-[28rem] max-w-full">
          <AIResponseBlock
            persona={{ name: "Aiko", avatar: "A" }}
            contextLabel="Explore"
            content={SAMPLE}
            sources={[
              { type: "pdf", label: "onboarding-guide.pdf" },
              { type: "youtube", label: "Studio walkthrough" },
              { type: "url", label: "docs.aisquare.com" },
            ]}
            confidence={0.92}
            latency="1.2s"
            model="claude-opus-4-8"
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Body only" caption="no sources / metadata">
        <div className="w-[28rem] max-w-full">
          <AIResponseBlock
            persona={{ name: "Studio Assistant" }}
            content="Short answer with no sources or metadata row."
            animate={false}
          />
        </div>
      </VariantBlock>
    </Section>
  );
}
